import React, { ElementType, createElement } from 'react';

import { PresenceStatus } from '@/shared/types/presence';

export const IconComponent = ({ icon }: { icon: ElementType | React.JSX.Element }) => {
  if (typeof icon === 'object') {
    return icon;
  } else if (typeof icon === 'function') {
    return createElement(icon);
  }
  return null;
};

/**
 * Sort order for agent presence. Partial so an unexpected status from the server
 * falls back instead of producing `NaN` inside a comparator.
 */
export const AGENT_STATUS_PRIORITY: Partial<Record<PresenceStatus, number>> = {
  [PresenceStatus.ONLINE]: 1,
  [PresenceStatus.AWAY]: 2,
  [PresenceStatus.OFFLINE]: 3,
};
